import React from 'react'
import { relative } from 'common/util/date'

const RelativeDate = ({ date }) => relative(date)

export default React.memo(RelativeDate)
